import { render, staticRenderFns } from "./PersonaSwitcherSidebar.vue?vue&type=template&id=21ac6c10&scoped=true&"
import script from "./PersonaSwitcherSidebar.vue?vue&type=script&lang=js&"
export * from "./PersonaSwitcherSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PersonaSwitcherSidebar.vue?vue&type=style&index=0&id=21ac6c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ac6c10",
  null
  
)

export default component.exports